import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
interface FilterEmptyStateProps {
  /** Heading, e.g. "No novels match your filters." */
  title: string;
  /** Guidance line beneath the heading. */
  message: string;
  /** Where the reset link points (e.g. "/browse" or "/genre/<slug>"). */
  clearHref: string;
  /** Reset link label. */
  clearLabel?: string;
}

/**
 * Shared "no results" card for the browse + genre filter surfaces. Centralizes
 * the card chrome so both pages stay visually in sync; the copy is passed in
 * per surface.
 */
export function FilterEmptyState(t0) {
  const $ = _c(11);
  const {
    title,
    message,
    clearHref,
    clearLabel: t1
  } = t0;
  const clearLabel = t1 === undefined ? "Clear filters \u2192" : t1;
  let t2;
  if ($[0] !== title) {
    t2 = <h3 className="font-heading text-lg font-bold text-landing-heading">{title}</h3>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== message) {
    t3 = <p className="mx-auto mt-2 max-w-md text-sm text-landing-body">{message}</p>;
    $[2] = message;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== clearHref || $[5] !== clearLabel) {
    t4 = <Link href={clearHref} className="mt-5 inline-flex items-center text-sm font-medium text-brand-light hover:text-brand-lightest">{clearLabel}</Link>;
    $[4] = clearHref;
    $[5] = clearLabel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <div className="rounded-2xl border border-landing-border bg-card/40 p-10 text-center">{t2}{t3}{t4}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}